'use strict';

$(function () {
  $('body').addClass('is-loaded');
});

{
  // ----------------------------------------------------------------
  // ナビゲーション開閉
  // ----------------------------------------------------------------
  const $nav      = $('.js-kF-nav');
  const $navLink      = $('.js-kF-nav a');
  const $overlay  = $('.js-kF-nav-overlay');
  const $openBtn  = $('.js-kF-nav-btn');
  const $sentinel = $('.js-kF-nav-focus');

  $sentinel.on('focus', function () {
    $openBtn.trigger('focus');
  });

  function openNav() {
    $nav.addClass('is-open');
    $overlay.addClass('is-open');
    $openBtn.addClass('is-open').attr('aria-expanded', 'true').attr('aria-label', 'メニューを閉じる');
    $('body').css('overflow', 'hidden');
  }

  function closeNav() {
    $nav.removeClass('is-open');
    $overlay.removeClass('is-open');
    $openBtn.removeClass('is-open').attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く').trigger('focus');
    $('body').css('overflow', '');
  }

  $openBtn.on('click', function () {
    $nav.hasClass('is-open') ? closeNav() : openNav();
  });
  $overlay.on('click', closeNav);
  $navLink.on('click', closeNav);

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $nav.hasClass('is-open')) {
      closeNav();
    }
  });

  $(window).on('resize', function () {
    if (window.innerWidth >= 960 && $nav.hasClass('is-open')) {
      closeNav();
    }
  });

  // ----------------------------------------------------------------
  // 商品タブ切り替え
  // ----------------------------------------------------------------
  $('.js-kF-products-tab').on('click', function () {
    const target = $(this).data('target');

    $('.js-kF-products-tab').removeClass('is-active');
    $(this).addClass('is-active');

    $('.js-kF-panel').removeClass('is-active');
    $('#panel-' + target).addClass('is-active');
  });

  // PC cta
  $('.js-kF-pc-products-tab').on('click', function () {
    const target = $(this).data('target');

    $('.p-kF-pc__product-panels').addClass('is-manual');
    $('.js-kF-pc-panel').removeClass('is-active');
    $('#panel-' + target).addClass('is-active');
  });

  // ----------------------------------------------------------------
  // ナビ内 Products サブリンク（パネル開封 → スクロール）
  // ----------------------------------------------------------------
  $(document).on('click', '.js-kF-nav-link[data-panel]', function () {
    const panelTarget = $(this).data('panel');

    // 対応するタブボタンをクリックしてパネルを開く
    const $tab = $('.js-kF-products-tab[data-target="' + panelTarget + '"]');
    if ($tab.length && !$tab.hasClass('is-active')) {
      $tab.trigger('click');
    }
  });

  // ----------------------------------------------------------------
  // COLORカラーチャート スクロール切り替え
  // ----------------------------------------------------------------
  const scrollBtn = $('.js-kF-color-btn')
  scrollBtn.on('click', function () {
    const scrollEl = $('.js-kF-color-scroll')[0];
    const isScrolled = scrollEl.scrollLeft > 10;

    scrollEl.scrollTo({ left: isScrolled ? 0 : scrollEl.scrollWidth, behavior: 'smooth' });
    scrollBtn.toggleClass('is-scrolled', !isScrolled);
    scrollBtn.attr('aria-label', !isScrolled ? 'カラーチャートに戻る' : 'カラーカードを表示');
  });

  $('.js-kF-color-scroll').on('scroll', function () {
    const isScrolled = this.scrollLeft > 10;
    scrollBtn.toggleClass('is-scrolled', isScrolled);
    scrollBtn.attr('aria-label', isScrolled ? 'カラーチャートに戻る' : 'カラーカードを表示');
  });

  // ----------------------------------------------------------------
  // Before/After 比較スライダー
  // ----------------------------------------------------------------
  $(document).on('mousedown touchstart', '.js-kF-compare-btn', function (e) {
    const $container = $(this).closest('.js-kF-compare');
    let dragging = true;

    function updatePos(clientX) {
      const rect = $container[0].getBoundingClientRect();
      let pos = (clientX - rect.left) / rect.width * 100;
      pos = Math.max(0, Math.min(100, pos));
      $container[0].style.setProperty('--compare-pos', pos + '%');
    }

    $(document).on('mousemove.compare touchmove.compare', function (e) {
      if (!dragging) return;
      const clientX = e.type === 'touchmove'
        ? e.originalEvent.touches[0].clientX
        : e.clientX;
      updatePos(clientX);
    });

    $(document).one('mouseup touchend', function () {
      dragging = false;
      $(document).off('.compare');
    });

    e.preventDefault();
  });

  // ----------------------------------------------------------------
  // 全成分表示 アコーディオン
  // ----------------------------------------------------------------
  $(document).on('click', '.js-kF-accordion-trigger', function () {
    const $trigger = $(this);
    const $body    = $trigger.closest('.js-kF-accordion').find('.js-kF-accordion-body');
    const $icon    = $trigger.find('.js-kF-accordion-icon');
    const isOpen   = $icon.hasClass('is-open');

    if (isOpen) {
      $body.slideUp(400);
      $trigger.attr('aria-expanded', 'false');
      $icon.removeClass('is-open');
    } else {
      $body.slideDown(400);
      $trigger.attr('aria-expanded', 'true');
      $icon.addClass('is-open');
    }
  });

  // ----------------------------------------------------------------
  // スクロールアニメーション
  // ----------------------------------------------------------------
  const $targets = $('.js-target');

  if ($targets.length) {
    function checkTargets() {
      const windowBottom = $(window).scrollTop() + $(window).height() * 0.8;
    
      $targets.not('.is-animated').each(function () {
        const $el = $(this);
        // 非アクティブなタブパネル内の要素はスキップ
        const $panel = $el.closest('.js-kF-panel');
        if ($panel.length && !$panel.hasClass('is-active')) return;
        // 要素の上端がビューポートの下から20%に入ったら発火
        if (windowBottom > $el.offset().top) {
          $el.addClass('is-animated');
        }
      });
    
      // 全要素にis-animatedが付いたらスクロール監視を解除
      if (!$targets.not('.is-animated').length) {
        $(window).off('scroll.jsTarget');
      }
    }
    
    // スクロール時：画面内に入った要素を発火
    $(window).on('scroll.jsTarget', checkTargets);
  }
}
